import React, { useEffect, useRef, useState } from 'react';
import RecepcionesNH3 from './Tablas/RecepcionesNH3';
import RecepcionesFletes from './Tablas/RecepcionesFletes';
import CardEmpty from '../../../Utils/Cards/CardEmpty';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Select from 'react-select';
import { NotificationManager } from 'react-notifications';
import { FincasApi } from '../../../Utils/APIs/FincasApi';

/**
 * Componente principal para el reporte de bonificaciones.
 * Muestra las recepciones donde se aplicó bonificación por uso de NH3 y por costo de flete.
 * Permite filtrar por finca y rango de fechas.
 * @returns {JSX.Element} Componente ReporteBonificaciones.
 */
const ReporteBonificaciones = (props) => {
    const { proveedorId } = props;

    // FILTROS
    const [filtros, setFiltros] = useState({
        finca_id: null,
        fecha_inicial: moment().startOf('week').isoWeekday(0),
        fecha_fin: moment().startOf('week').isoWeekday(6),
        // fecha_inicial: moment("2023-07-02"),
        // fecha_fin: moment("2023-07-03"),
    })

    const { fincasProveedor, getFincasProveedorForSelect } = FincasApi();

    useEffect(() => {
        setFiltros({
            ...filtros,
            finca_id: null,
        })
        getFincasProveedorForSelect(proveedorId);
    }, [proveedorId]);

    const recepcionesNH3Ref = useRef();
    const recepcionesFletesRef = useRef();

    const aplicarFiltros = () => {
        const fecha_inicial = moment(filtros.fecha_inicial).format("YYYY-MM-DD");
        const fecha_fin = moment(filtros.fecha_fin).format("YYYY-MM-DD");

        if (fecha_inicial === 'Invalid date' || fecha_fin === 'Invalid date') return;
        if (fecha_inicial > fecha_fin) {
            NotificationManager.error('Rango de fechas no válido', 'ERROR');
            return
        }

        recepcionesNH3Ref.current.aplicarFiltros();
        recepcionesFletesRef.current.aplicarFiltros();
    }

    return (
        <div className='dash-prov__bonificaciones'>
            <CardEmpty>
                {/* FILTROS */}
                <div className="dash-prov-recep-bonif__filters">
                    <div className="dash-prov-recep-bonif__filter">
                        <label>Fecha Inicial</label>
                        <DatePicker
                            showPopperArrow={false}
                            dateFormat="DD/MM/YYYY"
                            placeholderText="Fecha inicial"
                            onChange={(value) => { setFiltros({ ...filtros, fecha_inicial: value }) }}
                            selected={filtros.fecha_inicial}
                            maxDate={filtros.fecha_fin}
                        />
                    </div>
                    <div className="dash-prov-recep-bonif__filter">
                        <label>Fecha Final</label>
                        <DatePicker
                            showPopperArrow={false}
                            dateFormat="DD/MM/YYYY"
                            placeholderText="Fecha final"
                            onChange={(value) => { setFiltros({ ...filtros, fecha_fin: value }) }}
                            selected={filtros.fecha_fin}
                            minDate={filtros.fecha_inicial}
                        />
                    </div>
                    <div className="dash-prov-recep-bonif__filter">
                        <label>Finca</label>
                        <Select
                            className='react-select-container'
                            backspaceRemovesValue={false}
                            isMulti={false}
                            isSearchable={true}
                            isClearable={true}
                            options={fincasProveedor}
                            onChange={(value) => {
                                const finca_id = value ? value.value : null;
                                setFiltros({ ...filtros, finca_id: finca_id })
                            }}
                            value={fincasProveedor.find(finca => finca.value === filtros.finca_id) || null}
                        />
                    </div>
                    <button className="btn btn-primary"
                        onClick={aplicarFiltros}>
                        Buscar
                    </button>
                </div>
            </CardEmpty>
            <RecepcionesNH3 filtros={filtros} proveedorId={proveedorId} ref={recepcionesNH3Ref} />
            <RecepcionesFletes filtros={filtros} proveedorId={proveedorId} ref={recepcionesFletesRef} />
        </div>
    )
};

export default ReporteBonificaciones;
